import { Controller, useFormContext } from "react-hook-form";

import { Select } from "ui/select";
import ThemeInputNumber from "containers/admin/clients/client/theme-page/preview/components/theme-input-number/theme-input-number";

import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";
import { useButtonWidth } from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/components/button-width/use-button-width";

import { BUTTON_WIDTH_OPTIONS } from "containers/admin/clients/client/theme-page/preview/sub-tabs/button/button.constants";

import { CustomSelectOption } from "containers/admin/clients/client/theme-page/preview/preview.types";

const ButtonWidth = () => {
  const { control, watch } = useFormContext();
  const { isEditMode } = useThemePreviewContext();
  const {
    getButtonWidthSelectValue,
    handleWidthChange,
    handleWidthCustomChange,
    widthArrowHelper,
    handleWidthBlur,
    handleWidthKeyDown,
  } = useButtonWidth();

  const widthValue = watch("button.width.name")?.value;
  const isFixed = widthValue === "fixed";

  return (
    <div className="flex gap-2 items-end">
      <div className={isFixed ? "w-2/3" : "w-full"}>
        <Controller
          key="button.width.name"
          name="button.width.name"
          control={control}
          render={({ field }) => (
            <Select
              label="Width"
              ariaLabel="Width"
              selectName="button-select-width"
              disableClearable
              options={BUTTON_WIDTH_OPTIONS}
              disabled={!isEditMode}
              {...field}
              value={getButtonWidthSelectValue(field.value)}
              onChange={(el) => {
                if (el) {
                  handleWidthChange(el, field.onChange);
                }
              }}
            />
          )}
        />
      </div>
      {isFixed && (
        <div className="w-1/3">
          <ThemeInputNumber
            name="button.width.custom"
            label="Value (%)"
            onValueChange={(value, onChange) => handleWidthCustomChange(value, onChange)}
            onArrowUp={(field) => widthArrowHelper(field, 5)}
            onArrowDown={(field) => widthArrowHelper(field, -5)}
            onBlur={handleWidthBlur}
            onKeyDown={handleWidthKeyDown}
            minValue={20}
            defaultValue={20}
            step={5}
          />
        </div>
      )}
    </div>
  );
};

export default ButtonWidth;
